"use client";

import * as NavigationMenu from "@radix-ui/react-navigation-menu";
import type { RefAttributes } from "react";

export const NavMenuContent = (
	props: NavigationMenu.NavigationMenuContentProps & RefAttributes<HTMLDivElement>,
) => {
	return <NavigationMenu.Content {...props} />;
};
